import { Component, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";
@Component({
  selector: 'app-unsuccess-modal',
  templateUrl: './failed-modal.component.html',
  styleUrls: ['./failed-modal.component.scss']
})
export class UnSuccessModalComponent implements OnInit  {

  public onClose: Subject<boolean> = new Subject();

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {


  }

  closeModal() {
    this.activeModal.close();
  }


}
